module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-view-resumenes-platform/master-view-resumenes-platform.component.scss
// module id = ./src/app/master/master-view-resumenes-platform/master-view-resumenes-platform.component.scss
// module chunks = main